import { Component, OnInit, ViewChild } from '@angular/core';
import { MenuController, IonContent, NavController, Platform } from '@ionic/angular';
import { AuthService } from './services/auth.service';
import { PtyLdService } from './services/pty-ld.service';
import { PtySocketService } from './services/pty-socket.service';
import { PtyNotificationService } from './services/pty-notification.service';
import {ActivatedRoute, Router} from '@angular/router';
import { PTY_CONFIG } from './config/pty-config';
import { PtyWsService } from './services/pty-ws.service';
import { Storage } from '@ionic/storage-angular';
import { ModalController } from '@ionic/angular';
import { OnVacationComponent } from 'src/app/components/on-vacation/on-vacation.component';
import { waitForAsync } from '@angular/core/testing';
import { register } from 'swiper/element/bundle';
import { environment } from 'src/environments/environment';
// Doesn't work with import for some reason
const moment = require('moment/min/moment-with-locales');
import {lang} from "moment";
import { TranslationService } from './services/translation.service';
import { Events } from './services/events.service';
import { BadgeService } from "./services/badge.service";
import { AppInitService } from "./app-init.service";
import { DeepLinkService } from "./services/deep-link.service";
import { SplashScreen } from '@capacitor/splash-screen';

// Register swiper
register();

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
    @ViewChild(IonContent, { static: true }) content: IonContent;

    isMobile = false;
    faqurl;
    helpurl;
    currentuser;
    localeChanged = false;
    didInit = false;
    pdfRemoteServerUrl = (this.platform.is('ios') || this.platform.is('android')) ? environment.PDF_REMOTE_SERVER_URL : '';

    public appPages = [
        {
            title: 'Home',
            url: '/home',
            icon: 'home',
            isIonIcon: true,
            toggle: false,
            Tip: this._translationService.translate('Home')
        },{
            title: 'Conversations',
            url: '/seekers-pool',
            isIonIcon: true,
            icon: 'chatbubbles',
            hasBadge: true,
            isConversation: true,
            Tip: this._translationService.translate('Inbox'),
            toggle: true,
        }, {
            title: 'Disciples',
            url: '/tab-home/tab-disciples',
            isFontAwesomeIcon: true,
            Tip: this._translationService.translate('Disciples'),
            icon: 'fa-hands-helping'
        }, {
            title: 'Resources',
            isFontAwesomeIcon: true,
            icon: 'fa-briefcase',
            Tip: this._translationService.translate('ManageMyResources'),
            children: [
                // {
                //     title: 'Bible',
                //     icon: 'fas fa-bible',
                //     url: '/resources/bible',
                //     isIonIcon: false
                // },
                {
                    title: 'Documents',
                    icon: 'images',
                    url: '/resources/documents',
                    isIonIcon: true,
                    Tip: this._translationService.translate('ManageDocuments')
                },
                {
                    title: 'HelpfulLinks',
                    icon: 'link',
                    url: '/resources/links',
                    isIonIcon: true,
                    Tip: this._translationService.translate('ManageLinks')
                },
                {
                    title: 'Templates',
                    icon: 'clipboard',
                    url: '/resources/templates',
                    isIonIcon: true,
                    Tip: this._translationService.translate('ManageTemplates')
                },
            ]

        }, {
            title: 'Help',
            isFontAwesomeIcon: true,
            icon: 'fa fa-question-circle',
            Tip: this._translationService.translate('AskForHelp'),
            children: [

                // {
                //     title: 'MessageLeader',
                //     url: '/contact-leader',
                //     isIonIcon: false,
                //     icon: 'fa-bullhorn'
                // },
                {
                    title: 'Support',
                    isFontAwesomeIcon: true,
                    icon: 'fa-bullhorn',
                    href: environment.WS_END_POINT + 'fresh-desk-redirect',
                    Tip: this._translationService.translate('AskForSupport')
                },
                {
                    title: 'Training',
                    url: '/training',
                    isIonIcon: true,
                    icon: 'barbell-outline',
                    Tip: this._translationService.translate('Guide')
                },
                 
                {
                    title: 'FAQ',
                    icon: 'images',
                    href: this.pdfRemoteServerUrl + '/assets/Path_FAQs.pdf ',
                    isIonIcon: true,
                    Tip: this._translationService.translate('FAQ')
                },
            ]

        }, {
            title: 'Training',
            isIonIcon: true,
            icon: 'barbell-outline',
            Tip: this._translationService.translate('Guide'),
            children: [
                {
                    title: 'Videos',
                    url: '/training',
                    isFontAwesomeIcon: true,
                    icon: 'fa-bullhorn',
                    Tip: this._translationService.translate('TrainingVideos')
                },
                {
                    title: 'e-Learning',
                    isFontAwesomeIcon: true,
                    icon: 'fa-chalkboard',
                    href: 'https://gmotraining.docebosaas.com/learn',
                    Tip: this._translationService.translate('DoceboLoginPage')
                },

                {
                    title: 'Virtual Seeker Chat',
                    url: '/training-seekers-select',
                    isIonIcon: true,
                    icon: 'chatbubbles',
                    Tip: this._translationService.translate('Guide')
                },
            ]
        },
        {
            title: 'Chats',
            icon: 'fa-users',
            hasBadge: true,
            isGroupChat: true,
            isAdminOmChat: true,
            isFontAwesomeIcon: true,
            Tip: this._translationService.translate('Chats'),
            children: [

                {
                    title: 'CommunityChats',
                    url: '/groups',
                    isFontAwesomeIcon: true,
                    icon: 'fa-users',
                    Tip: this._translationService.translate('CommunityChats')
                },
                {
                    title: 'MessageLeader',
                    url: '/contact-leader',
                    isIonIcon: true,
                    icon: 'megaphone',
                    hasBadge: true,
                    isAdminOmChat: true,
                    Tip: this._translationService.translate('MessageLeader')
                },
            ]


        }, {
            title: 'Settings',
            isIonIcon: true,
            icon: 'settings',
            Tip: this._translationService.translate('Settings'),
            children: [
                {
                    title: 'Calendar',
                    url: '/calendar',
                    isIonIcon: true,
                    icon: 'calendar',
                    Tip: this._translationService.translate('Calendar')
                }, {
                    title: 'Notifications',
                    url: '/notifications',
                    isIonIcon: true,
                    icon: 'notifications',
                    hasBadge: true,
                    isNotification: true,
                    Tip: this._translationService.translate('ManageMyNotifications')
                }, {
                    title: 'MyProfile',
                    url: '/tab-home/tab-profile',
                    isIonIcon: true,
                    icon: 'person',
                    Tip: this._translationService.translate('MyProfile')
                }
            ]

        },
    ];

    TipBubbles = [
        { iconName: 'chatbubbles', Tip: 'Conversations', isIonIcon: true },
        { iconName: 'fa-users', Tip: 'Community Group Chats', isFontAwesomeIcon: true },
        { iconName: 'fa-hands-helping', Tip: 'Disciples', isFontAwesomeIcon: true },
        { iconName: 'person', Tip: 'My Profile', isIonIcon: true },
    ];

    seekersWaiting = 0;
    group_unread_count = 0;
    adminOmUnreadMessageCount = 0;
    href = '';
    NotificationUnreadCount = 0;
    displaytooltip;
    pageName: any = {};
    unreadMessageCount;
    x=2;

    constructor(
        private platform: Platform,
        private menuCtrl: MenuController,
        private navCtrl: NavController,
        private events: Events,
        public router: Router,
        private route: ActivatedRoute,
        private ld: PtyLdService,
        public auth: AuthService,
        private ws: PtyWsService,
        private notification: PtyNotificationService,
        private socket: PtySocketService,
        private storage: Storage,
        public modalCtrl: ModalController,
        private _translationService: TranslationService,
        private badgeService: BadgeService,
        private appInit: AppInitService,
        private deepLinkService: DeepLinkService,
    ) {
        const userData = localStorage.getItem('pty_user_data');
        if (userData) {
            this.currentuser = JSON.parse(userData);
        } else {
            this.currentuser = {};
        }
    }
    async ngOnInit() {
        await this.appInit.Init();

        // returns the correct faq url as this.faqurl based on the app locale
        // app_locale is a local storage variable set in APP_INITIALIZER before app.component loads
        this.initializeFAQs();

        // perform various app initialization things
        this.initializeApp();
        this.setmenu(this.currentuser.level, this.appPages);

        /* List all the events we subscribe to at the app level */

        /* TO DO: refactor so we no longer need this.setAppLocale() - see comment on setAppLocale() method */
        this.events.subscribe('translationChange', async (lang: any) => {
            await this.setAppLocale();
        });

        this.events.subscribe('show-menu', (show: boolean) => {
            this.menuCtrl.enable(show, 'menu1');
        });
        this.events.subscribe('change-waiting-seekers', (waiting: any) => {
            this.seekersWaiting = waiting;
        });

        this.events.subscribe('updateUnreadMessagesOnAPP', async () => {
            await this.getUnreadMessages();
        });

        this.events.subscribe('ToolTipStatus', () => {
            if (!localStorage.getItem('tooltip')) {
                localStorage.setItem('tooltip', 'true');
            }
            this.displaytooltip = JSON.parse(localStorage.getItem('tooltip'));

        });

        this.events.subscribe('MessageNotification', (notification) => {
            // this.sendMessageNotification(notification);
            this.getNotificationUnreadCount();
        });

        this.events.subscribe('UpdateNotification', () => {
            // This function used to increment, but that caused problems due to caching
            //  So we're going to do an API call to refresh to keep things consistent between reloads
            this.getNotificationUnreadCount();
        });

        this.events.subscribe('ResetNotificationCount', count => {
            localStorage.setItem('NotificationUnreadCount', count + '');
            this.NotificationUnreadCount = count;
            this.events.publish('updateNotificationBadge');
        })

        this.events.subscribe('ReadNotification', () => {
            let count = +localStorage.getItem('NotificationUnreadCount');
            count = count - 1;
            localStorage.setItem('NotificationUnreadCount', count + '');
            this.NotificationUnreadCount = count;
            this.events.publish('updateNotificationBadge');
        });

        this.events.subscribe('AdminOmUnreadCountIncrement', () => {
            let newCount = this.adminOmUnreadMessageCount;
            if (typeof newCount === 'string') {
                newCount = parseInt(newCount);
            }
            newCount++;
            this.currentuser.admin_om_unread_count = newCount;
            this.adminOmUnreadMessageCount = newCount;
            console.log('updated!!!', this.adminOmUnreadMessageCount);
            localStorage.setItem('pty_user_data', JSON.stringify(this.currentuser));
        });

        this.events.subscribe('AdminOmUnreadCount', (newCount) => {
            this.currentuser.admin_om_unread_count = newCount;
            this.adminOmUnreadMessageCount = newCount;
            localStorage.setItem('pty_user_data', JSON.stringify(this.currentuser));
        });

        setInterval(() => {this.getNotificationUnreadCount();}, (180*1000));
        this.didInit = true;
        await SplashScreen.hide();
    }

    setmenu(level, pages) {
        if (level === 'Guide') {
            pages.splice(2, 1);
        }
        this.appPages = pages;

    }

    ngOnDestroy() {
        // this.events.unsubscribe('updateUnreadMessages', null);
        this.events.unsubscribe('ToolTipStatus', null);
        this.events.unsubscribe('updateUnreadMessagesOnAPP', null);
        this.events.unsubscribe('UpdateNotification', null);
        clearInterval(this.auth.checkSessionApiVersionInterval);
    }
    checktab(e) {
        if (e.title == 'Settings') {
            setTimeout(() => {
                if (this.content) {
                    this.content.scrollToBottom(0)
                }
            }, 10)
        }

        // Collapse menu items when clicks on another menu item
        this.appPages.map((element) => {
            if(element != e && element.hasOwnProperty('open')){
                element['open'] = false;
            }
        });
    }
    sendMessageNotification(notification: any) {
        let sender_name = notification.extra_data.msg_body.from.value[0].name;
        let sender_email = notification.extra_data.msg_body.from.value[0].email;
        let conversation_uuid = notification.extra_data.conversation_uuid;
        let NotificationData = {
            email: sender_email,
            receiver_system: 'S',
            type: 'chat_notification',
            otherdata: {
                body: `${sender_name} has responded you, see their message`,
                conversation_uuid: conversation_uuid,
                seeker_name: sender_name,
                type: 'chat_notification',
            }
        };

        this.ws.invokeURL('insert_notifications', NotificationData).subscribe((result: any) => {
            // console.log(result);
        }, (err: any) => {
            console.error('Error taking conversation', err);
        });
    }

    // returns the correct faq url as this.faqurl based on the app locale
    initializeFAQs(){

        // app_locale is a local storage variable set in APP_INITIALIZER before app.component loads
        const locale = localStorage.getItem('app_locale');

        if (locale == "ar") {
            this.faqurl='/assets/ar/Arabic_path_app_faq.pdf';
            this.helpurl='https://omhelpdesk.freshdesk.com';
        } else if (locale == "zh") {
            this.faqurl='/assets/zh/Chinese_path_app_faq.pdf';
            this.helpurl='https://omhelpdesk.freshdesk.com';
        } else if (locale == "en") {
            this.faqurl='/assets/Path_FAQs.pdf';
            this.helpurl='https://omhelpdesk.freshdesk.com';
        } else if (locale == "fr") {
            this.faqurl='/assets/fr/French_path_app_faq.pdf';
            this.helpurl='https://gmoboite.freshdesk.com';
        } else if (locale == "hi") {
            this.faqurl='/assets/hi/Hindi_path_app_faq.pdf';
            this.helpurl='https://omhelpdesk.freshdesk.com';
        } else if (locale == "id") {
            this.faqurl='/assets/id/Indonesian_path_app_faq.pdf';
            this.helpurl='https://indonesianhelp.freshdesk.com';
        } else if (locale == "pt") {
            this.faqurl='/assets/pt/Portuguese_path_app_faq.pdf';
            this.helpurl='https://portuguese.freshdesk.com';
        } else if (locale == "ru") {
            this.faqurl='/assets/ru/Russian_path_app_faq.pdf';
            this.helpurl='https://gmo4u.freshdesk.com';
        } else if (locale == "es") {
            this.faqurl='/assets/es/Spanish_path_app_faq.pdf';
            this.helpurl='https://contactoarc.freshdesk.com';
        } else {
            this.faqurl='/assets/Path_FAQs.pdf';
            this.helpurl='https://omhelpdesk.freshdesk.com';
        }

        this.faqurl = this.pdfRemoteServerUrl + this.faqurl;
    }

    // perform various app initialization things
    initializeApp() {
        const self = this;

        this.displaytooltip = JSON.parse(localStorage.getItem('tooltip'));
        if (!localStorage.getItem('suggestedResponseStatus')) {
            localStorage.setItem('suggestedResponseStatus', 'true');
        }
        if (!localStorage.getItem('NotificationToggleStatus')) {
            localStorage.setItem('NotificationToggleStatus', 'true');
        }

        self.menuCtrl.enable(false, 'menu1');

        /*
        Returns a promise when the platform is ready and native functionality can be called.
        If the app is running from within a web browser, then the promise will resolve when the DOM is ready.
        */
        self.platform.ready().then(async () => {
            if (location.search) {
                const queryParams = new URLSearchParams(location.search);
                const switchUserToken = queryParams.get('suToken');
                if( switchUserToken ) {
                    await self.auth.checkForSwitchUser(switchUserToken);
                }
            }

            // do a check to see if the session is valid (this also does a check to see if localstorage user exists)
            let sessionValid = await self.auth.checkSessionApiVersion();

            // only show the loader if session is valid, if invalid, the loader is called from the auth.logout function inside
            // checkSessionApiVersion.  calling the loader to show twice causes a bug
            //
            if(sessionValid){
                await self.ld.showLoading(true, {fullScreen: true});
                this.auth.setAuthData();
                this.getAdminOmUnreadMessages();
            } else {
                localStorage.removeItem('pty_user_data');
                localStorage.removeItem('last_saw_announcements');
                localStorage.removeItem('NotificationUnreadCount');
            }

            if (self.platform.is('ios' || 'android' || 'iphone')) {
                self.isMobile = true;
            }

            // Present loading animation and wait to be ready

                // Subscribe to authentication state changes
                self.auth.authenticationState.subscribe(async state => {

                   //  if user is logged in...
                  // change localeChanged value to update translation pipe on navigation
                  if(this.auth.userData) self.localeChanged = true;

                  if(self.auth.userData && self.auth.userData.token) {
                        let index;
                        this.currentuser.level != 'Guide' ? index = 4 : index = 3;
                        this.appPages[index].children[0]['href'] += `?token=${self.auth.userData.token}`;
                  }

                  /* TODO: refactor this so it is called from APP INITIALIZER or a route resolver rather than use an if statement */
                    if (this.router.url.toString().indexOf('/collect-testimony') !== -1) {
                        await self.getTranslationForContact();
                    }

                    this.href = this.router.url;
                    this.href = this.href.toString();

                    if (state && self.auth.userData) {
                        try {
                            // We started getting "URL too long" errors due to too much junk being in the user object here
                            const minimalUserData = {
                                uuid: this.auth.userData.uuid,
                                user_info: this.auth.userData.user_info
                            };
                            this.socket.connect(minimalUserData);
                        } catch (err) {
                            console.log('Socket Connection error: ', err);
                            // ignore socket connect errors for local dev
                        }

                        /* TODO: refactor this so it is called from APP INITIALIZER or a route resolver rather than use an if statement */
                        if (self.auth.userData.status === 'N' || self.auth.userData.status === 'P') {
                            self.router.navigate(['/application', { socialNetwork: self.auth.userData.social_network != null }]);
                        } else {
                            /* TODO: refactor this so it is called from APP INITIALIZER or a route resolver rather than use an if statement */
                            if (this.href.indexOf('collect-testimony') !== -1) {
                                /*
                            } else if (this.href.indexOf('logging-out') === -1) {
                                self.router.navigate([PTY_CONFIG.DEFAULT_PATH], { replaceUrl: true });
                                 */
                            } else {
                                const userData = localStorage.getItem('pty_user_data');
                                if (userData) {
                                    this.currentuser = JSON.parse(userData);
                                    /* 
                                    NOTE: Uncommenting the following statement forces the display of the 'Virtual Seeker Chat' PATH
                                    main-menu item, which may be useful for testing purposes -- John
                                    */
                                    // this.currentuser.user.training_chat_ai = true;
                                } else {
                                    this.currentuser = {};
                                }
                                this.appPages.map((element) => {
                                    if(element.hasOwnProperty('open')){
                                        element['open'] = false;
                                    }
                                });                                
                                this.setmenu(this.currentuser.level, this.appPages);

                                // If there was a deep link click, but we couldn't dispatch it because we weren't logged in, dispatch it now.
                                const didDeepLinkRedirect = await this.deepLinkService.dispatchQueuedDeepLinkClicks();
                                if (!didDeepLinkRedirect) {
                                    /* otherwise, redirect to landing page and assign some app component variables */
                                    await self.router.navigate([PTY_CONFIG.DEFAULT_PATH], { replaceUrl: true });
                                }
                                self.events.publish('show-menu', true);
                                this.loadNotifications();
                                this.getNotificationUnreadCountFromAuth();
                                self.unreadMessageCount = self.auth.userData.unread_msg;
                                this.updateAppIconBadge(parseInt(self.unreadMessageCount));
                                self.adminOmUnreadMessageCount = self.auth.userData.admin_om_unread_messages;
                                if (this.auth.userData.vacation_uuid) {
                                    this.VacationScreen(this.auth.userData.vacation_uuid);
                                }
                                self.ld.showLoading(false);
                            }
                        }
                    } else {
                        try {
                            this.socket.disconnect();
                        } catch (err) {
                            // ignore socket connect errors for local dev
                        }
                        if (self.menuCtrl.isEnabled() && self.menuCtrl.isOpen()) {
                            self.menuCtrl.toggle().then(() => {
                                self.events.publish('show-menu', false);
                                // self.navCtrl.navigateBack('/login-normal');
                            });
                        } else {
                            // self.navCtrl.navigateBack('/login-normal');
                            self.events.publish('show-menu', false);
                        }
                    }
                });
                self.ld.showLoading(false);
        });
    }

    async VacationScreen(vacation_uuid) {
        const modal = await this.modalCtrl.create({
            component: OnVacationComponent,
            cssClass: 'showNotesModal',
            backdropDismiss: false,
            componentProps: { vacation_uuid: vacation_uuid }
        });
        return await modal.present();
    }

    updateAppIconBadge(badgeCount: number) {
        this.badgeService.set(badgeCount);
    }

    addNewSeeker(url) {
        this.router.navigate([url]);
    }

    /* DEPRECATED: this is only used when updateUnreadMessagesOnAPP event is published
        TODO: replace url with refactored API url  */

    getUnreadMessages() {
        let self = this;
        self.ws.invokeURL('get_unread_conversation', {}).subscribe((res: any) => {
            if (res.error == 0) {
                this.unreadMessageCount = res.result[0].unread_msg;
            }
        }, (err: any) => {
            console.error('Error While fetching Unread Count');
        });
    }

    getAdminOmUnreadMessages() {
        let self = this;
        self.ws.invokeURL('admin_om_unread_count', {}).subscribe((res: any) => {
            if (res.error == 0) {
                self.events.publish('AdminOmUnreadCount', res.unreadMessages);
            }
        }, (err: any) => {
            console.error('Error While fetching Unread Count');
        });

    }


    getTranslationForContact() {
        const seeker_uuid = this.route.snapshot.queryParamMap.get('s_uuid');
        this.ws.invokeURL('get_translation_for_contact', { seeker_uuid }).subscribe((res: any) => {
            if (res.error === 0) {
                const translation = res.result.rows[0].translation;
                if (translation !== null) {
                    if (localStorage.getItem('app_translation')) {
                        localStorage.removeItem('app_translation');
                    }
                    const defaultTranslations = require('../assets/i18n/en.json');
                    localStorage.setItem('app_translation', JSON.stringify({...defaultTranslations, ...translation}));
                }
            }
        }, (err: any) => {
            console.error('Translation not loaded', err);
        });
    }



    /* DEPRECATED: called when on event 'translationChange' is published
        TO DO: translationChange is published from languageComponent when user changes language.
        in languageComponent on change, Do a simple page refresh thather than publish an event and then remove this code */

    async setAppLocale() {
        const self = this;
        let apiPromise = new Promise((resolve, reject) => {
            self.ws.invokeURL('get_default_language_code', {}).subscribe((res: any) => {
                resolve(res);
            }, (err: any) => {
                reject(err);
            });
        });

        let locale = 'en';

        try {
            const res: any = await apiPromise;
            if (res.error === 0) {
                const defaultLocale = res.result[0].code_1;
                if (defaultLocale !== null) {
                    locale = defaultLocale;
                    if (localStorage.getItem('app_locale')) {
                        localStorage.removeItem('app_locale');
                    }
                }
            } else {

            }

            const languageCode = this.route.snapshot.queryParamMap.get('lang');
            if (languageCode) {
                locale = languageCode.substr(0, 2).toLowerCase();
            } else if (navigator) {
                locale = navigator.language;
                locale = locale.substr(0, 2).toLowerCase();
            }
            localStorage.setItem('app_locale', locale);
            moment.locale(locale);

            await this.getDefaultTranslation();
        } catch (err) {
            console.error('Locale not loaded');

        }
    }

    /* DEPRECATED: called inside setAppLocale, which is called when on event 'translationChange' is published
    TO DO: translationChange is published from languageComponent when user changes language.
    in languageComponent on change, Do a simple page refresh thather than publish an event and then remove this code */

    async getDefaultTranslation() {
        const self = this;
        const locale = localStorage.getItem('app_locale');

        self.ws.invokeURL('get_app_translation', {locale}).subscribe((res: any) => {
            if (res.error === 0) {
                const translation = res.result[0].translation;
                if (translation !== null && JSON.stringify(translation) !== localStorage.getItem('app_translation')) {
                    if (localStorage.getItem('app_translation')) {
                        localStorage.removeItem('app_translation');
                    }
                    const defaultTranslation = require('../assets/i18n/en.json');
                    localStorage.setItem('app_translation', JSON.stringify({...defaultTranslation, ...translation}));
                }
                self.ws.invokeURL('get_country_translation', {locale}).subscribe((res: any) => {
                    if (res.error === 0) {
                        const translation = res.result;
                        const currentTranslation = localStorage.getItem('country_translation');

                        setTimeout(() => {
                          const didTimeout = this.route.snapshot.queryParamMap.get('timeout');

                          if (translation !== null && JSON.stringify(translation) !== currentTranslation) {
                              if (!localStorage.getItem('country_translation')) {
                                  localStorage.setItem('country_translation', JSON.stringify(translation));

                                  // only reload the page when fetching non-default translations
                                  if (locale !== 'en' && !didTimeout) {
                                    location.reload();
                                  }
                                } else {
                                  localStorage.removeItem('country_translation');
                                  localStorage.setItem('country_translation', JSON.stringify(translation));
                                  // but always reload the page if incoming & present translations are out of sync
                                  !didTimeout && location.reload();
                              }
                          }
                        }, 100);

                    }
                }, (err: any) => {
                    console.error('Translation not loaded', err);
                });
            }
        }, (err: any) => {
            console.error('Translation not loaded', err);
        });
    }



    /* only called from app initialization */

    getNotificationUnreadCountFromAuth(){
        let unread = this.auth.userData.user_notifications.filter(e => e.is_read !== 1);
        this.NotificationUnreadCount = unread.length;
        localStorage.setItem('NotificationUnreadCount', JSON.stringify(this.NotificationUnreadCount));
        this.events.publish('updateNotificationBadge');
    }



    /* DEPRECATED: this is a method called when 'MessageNotification' event is published
        TODO: replace url with new refactored API url */

    async getNotificationUnreadCount() {

        try {
            const self = this;
            this.NotificationUnreadCount = 0;
            await self.ld.showLoading(false);
            self.ws.invokeURL('user_notifications', {}).subscribe((result: any) => {
                if (result.error === 0) {
                    let unread = result.notifications.filter(e => e.is_read !== 1);
                    this.NotificationUnreadCount = unread.length;

                    // Make sure to update the cache so it persists between reloads
                    this.auth.updateNotifications(unread);

                    self.ld.showLoading(false);
                    localStorage.setItem('NotificationUnreadCount', JSON.stringify(this.NotificationUnreadCount));
                    this.events.publish('updateNotificationBadge');
                } else {
                    self.ld.showLoading(false);
                }
            }, (err: any) => {
                self.ld.showLoading(false);
            });
        } catch (err) {

        }
    }

    /* only called from app initialization */

    loadNotifications() {
        let count = 0;
        this.auth.userData.group_notifications.forEach(function (e) {
            if (e.type === 'group_chat' && e.status === 'N') {
                count = count + 1;
            }
        });
        this.group_unread_count = count;
    }

    async logout() {

        this.auth.saveProfileWhileLoggingOut = true;
        
        // This router navigation to self is to manually trigger any confirmation guards prior to logging out
        await this.router.navigate(['.'], { relativeTo: this.route });
        await this.auth.getWaitForLogoutPromiseChain();

        // Disable confirmation guard to prevent spurious prompts
        this.events.publish('show-menu', false);
        this.checkForPendingTransactions();
        this.auth.logout();
    }

    checkForPendingTransactions() {

        let userTemplates = localStorage.getItem('myTemplateInstorage');
        userTemplates = JSON.parse(userTemplates);

        if (!userTemplates) return;

        const self = this;
        self.ws.invokeURL('conversation_templates', { option: 'reorder', templates: userTemplates }).subscribe((result: any) => {
            if (result.error === 0) {
                self.ld.showLoading(false);
            } else {
                self.ld.showLoading(false, { message: result.message });
            }
        }, (err: any) => {
            console.error('Error taking conversation', err);
            self.ld.showLoading(false, { message: 'UnknownError' });
        });
    }
}
